var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInspiration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2V5H13V2H11ZM17.3 6.4L18.7 7.8L20.5 6L19.1 4.6L17.3 6.4ZM3.5 6L5.3 7.8L6.7 6.4L4.9 4.6L3.5 6ZM13.0625 20.5625C12.7708 20.8542 12.4167 21 12 21C11.5833 21 11.2292 20.8542 10.9375 20.5625C10.6458 20.2708 10.5 19.9167 10.5 19.5H13.5C13.5 19.9167 13.3542 20.2708 13.0625 20.5625ZM15 18.5H9V17H15V18.5ZM14.975 16H9.025C8.40833 15.55 7.91667 14.9792 7.55 14.2875C7.18333 13.5958 7 12.8333 7 12C7 10.6167 7.4875 9.4375 8.4625 8.4625C9.4375 7.4875 10.6167 7 12 7C13.3833 7 14.5625 7.4875 15.5375 8.4625C16.5125 9.4375 17 10.6167 17 12C17 12.8333 16.8167 13.5958 16.45 14.2875C16.0833 14.9792 15.5917 15.55 14.975 16ZM8.7875 13.3625C8.97917 13.7875 9.24167 14.1667 9.575 14.5H14.425C14.7583 14.1667 15.0208 13.7875 15.2125 13.3625C15.4042 12.9375 15.5 12.4833 15.5 12C15.5 11.0333 15.1583 10.2083 14.475 9.525C13.7917 8.84167 12.9667 8.5 12 8.5C11.0333 8.5 10.2083 8.84167 9.525 9.525C8.84167 10.2083 8.5 11.0333 8.5 12C8.5 12.4833 8.59583 12.9375 8.7875 13.3625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInspiration);
export default __webpack_public_path__ + "static/media/icon-inspiration.17b15bfa1a6a2496427c1fb6afd56513.svg";
export { ForwardRef as ReactComponent };